<script setup lang="ts">
import { RouterView } from "vue-router";
</script>

<template>
  <RouterView />
  <div id="root"></div>
</template>

<style lang="scss">
label {
  display: inline-block;
  font-weight: 500;
}

.small-scrollbar {
  &::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: #e0e0e0;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #757575;
  }
}

.v-input__details {
  text-align: right;
  padding-right: 0 !important;
}
</style>
